module.exports = __webpack_public_path__ + "static/media/Polygon-blue.9aafe9da.svg";